import axios from "../../../../../../api/axiosInstance";
import {
  SaveAccountMappingsRequest,
  SaveAccountMappingsResponse,
} from "./types";

export const saveAccountMappings = async (
  companyUuid: string,
  request: SaveAccountMappingsRequest,
  signal?: AbortSignal,
): Promise<SaveAccountMappingsResponse> => {
  const response = await axios.post<SaveAccountMappingsResponse>(
    `/api/private/companies/${companyUuid}/quickbooks/account-mappings`,
    request,
    { signal },
  );
  return response.data;
};
